module.exports = __webpack_public_path__ + "images/ui-icons_222222_256x240.png";